const arredondar = (valor, casas = 2) => {
  const fator = Math.pow(10, casas);
  return Math.round((Number(valor) + Number.EPSILON) * fator) / fator;
};

const gerarGrupo = () =>
  `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

const clonarLote = (lote, quantidade) => {
  if (!lote) return lote;

  return {
    ...lote,
    quantidade,
  };
};

export const produtoExigeRetorno = (produto, quantidade) =>
  Boolean(
    produto?.retornavel &&
      produto?.id_produto_casco &&
      Number(produto?.preco_sem_retorno) > 0 &&
      Number.isInteger(Number(quantidade)) &&
      Number(quantidade) > 0
  );

export const dividirItemRetornavel = (item, quantidadeRetornada) => {
  const quantidadeTotal = Number(item.quantity);
  const retornados = Number(quantidadeRetornada);
  const semRetorno = quantidadeTotal - retornados;
  const descontoTotal = Number(item.discount || item.product?.desconto) || 0;
  const grupo = gerarGrupo();
  const produto = item.product || {};
  const configuracao = {
    grupo,
    id_produto_casco: Number(produto.id_produto_casco),
    descricao_produto_casco:
      produto.produto_casco?.descricao || produto.descricao_produto_casco || "",
    preco_sem_retorno: Number(produto.preco_sem_retorno),
  };

  const partes = [];
  if (retornados > 0) {
    partes.push({
      tipo: "com_retorno",
      quantidade: retornados,
      preco: Number(item.price),
      quantidadeRetornada: retornados,
    });
  }
  if (semRetorno > 0) {
    partes.push({
      tipo: "sem_retorno",
      quantidade: semRetorno,
      preco: Number(produto.preco_sem_retorno),
      quantidadeRetornada: 0,
    });
  }

  let descontoDistribuido = 0;
  return partes.map((parte, index) => {
    const ultimo = index === partes.length - 1;
    const desconto = ultimo
      ? arredondar(descontoTotal - descontoDistribuido)
      : arredondar((descontoTotal * parte.quantidade) / quantidadeTotal);
    descontoDistribuido = arredondar(descontoDistribuido + desconto);
    const totalPrice = arredondar(parte.preco * parte.quantidade - desconto);
    const vasilhame = {
      ...configuracao,
      tipo: parte.tipo,
      quantidade_retornada: parte.quantidadeRetornada,
    };

    return {
      ...item,
      product: {
        ...produto,
        preco: parte.preco,
        quantidade: parte.quantidade,
        desconto,
        total: totalPrice,
        lote_baixa: clonarLote(produto.lote_baixa, parte.quantidade),
      },
      price: parte.preco,
      quantity: parte.quantidade,
      discount: desconto,
      totalPrice,
      lote: clonarLote(item.lote, parte.quantidade),
      vasilhame,
    };
  });
};

export const atualizarVasilhameDoItem = (item, quantidade) => {
  if (!item?.vasilhame) return item;

  const novaQuantidade = Number(quantidade);
  const comRetorno = item.vasilhame.tipo === "com_retorno";

  return {
    ...item,
    vasilhame: {
      ...item.vasilhame,
      quantidade_retornada: comRetorno ? novaQuantidade : 0,
    },
    lote: clonarLote(item.lote, novaQuantidade),
    product: {
      ...item.product,
      lote_baixa: clonarLote(item.product?.lote_baixa, novaQuantidade),
    },
  };
};
